<template>
  <div class="columns">
    <div class="column">
      <label class="label">Yours</label>
      <ul>
        <li
          v-for="(item, idx) in labeledLocal"
          :key="'local-' + idx"
          class="mc-row"
        >
          <span class="mc-checkbox" :class="{ checked: item.checked }">
            <b-icon icon="check" size="is-small" v-if="item.checked" />
          </span>
          <span class="mc-label">
            {{ item.value }}
          </span>
        </li>
      </ul>
    </div>

    <div class="column">
      <label class="label">Theirs</label>
      <ul>
        <li
          v-for="(item, idx) in labeledServer"
          :key="'server-' + idx"
          class="mc-row"
        >
          <span class="mc-checkbox" :class="{ checked: item.checked }">
            <b-icon icon="check" size="is-small" v-if="item.checked" />
          </span>
          <span class="mc-label">
            {{ item.value }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConflictMultipleChoiceField',
  props: {
    local: {
      type: Array,
      default: () => [],
    },
    server: {
      type: Array,
      default: () => [],
    },
    resolved: {
      type: String,
      default: '',
    },
    module: {
      type: String,
      default: 'publisher',
    },
  },
  computed: {
    labeledLocal() {
      return this.formatOptions(this.local);
    },
    labeledServer() {
      return this.formatOptions(this.server);
    },
  },
  methods: {
    formatOptions(source) {
      return source.map((item) => ({
        value: item.defaultMC,
        checked: !!item.checked,
      }));
    },
  },
};
</script>

<style scoped>
ul {
  margin: 0;
  padding-left: 0;
}

li.mc-row {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0.5em;
}

.mc-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  flex-shrink: 0;
}

.mc-checkbox.checked {
  background: #23d160;
  border-color: #23d160;
  color: #fff;
}

.mc-label {
  font-size: 1rem;
  color: #4a4a4a;
  font-weight: bold;
}
</style>
